var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app-container"}},[_c(_vm.resolveLayout,{tag:"component"},[_c('router-view')],1),(_vm.isAuthenticated)?_c('NotifPermissionBanner',{on:{"activer":_vm.initWebPush}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }